import { Outlet } from 'react-router-dom';
import CoordinatorFooter from "../components/common/CoordinatorFooter";
import {isCoordinator} from "../utils/authUtils";
import Footer from "../components/common/Footer";

const FooterLayout = () => {
    return (
        <>
            <Outlet />
            {isCoordinator() ? <CoordinatorFooter /> : <Footer />}
        </>
    );
};

export default FooterLayout;
